// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
	apiKey: 'AIzaSyD0pNEsqn8snvjz4EbiJ350rA5cDP8FVA8',
	authDomain: 'movie-quote-guesser.firebaseapp.com',
	projectId: 'movie-quote-guesser',
	storageBucket: 'movie-quote-guesser.firebasestorage.app',
	messagingSenderId: '284944005487',
	appId: '1:284944005487:web:54edf7c14b0896ecdf909a',
	measurementId: 'G-WJC1R3063E',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const analytics = getAnalytics(app);

const db = getFirestore(app);

export { db };
